import React, { useState, useEffect } from 'react';

const withGlobalExceptionDetailDialog = (WrapComponent, setDialog) => (props) => {
  const [open, setOpen] = useState(false);
  const [errorInfo, setErrorInfo] = useState({});
  useEffect(() => {
    setDialog({
      show: (newErrorInfo) => {
        setOpen(true);

        setErrorInfo(newErrorInfo);
      },
      hide: () => {
        setOpen(false);
      },
    });
  });

  const closeExceptionDetailDialog = () => {
    setOpen(false);
  };

  return (
    <WrapComponent
      open={open}
      onClose={closeExceptionDetailDialog}
      errorInfo={errorInfo}
      {...props}
    />
  );
};

export default withGlobalExceptionDetailDialog;
